/**
 * ============================================================
 * MONTE HERMOM | LAUDO LAYOUT
 * ============================================================
 * ARQUIVO: /src/components/laudo/LaudoLayout.jsx
 *
 * Envolve as 6 abas do laudo:
 *   ABERTURA → VISTORIA → AMOSTRAS → ANÁLISE → REVISÃO → FINALIZAÇÃO
 * ============================================================
 */

import React, { useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useAuthSaaS } from '../../context/AuthSaaSContext';
import MenuParadigmaLateral from '../perfil/MenuParadigma_lateral';
import LaudoHeader from './LaudoHeader';
import LaudoAbas from './LaudoAbas';

export default function LaudoLayout() {
  const { codigo } = useParams();
  const { usuario } = useAuthSaaS();

  const [abaAtiva, setAbaAtiva] = useState('LAUDOS');
  const [menuFinanceiro, setMenuFinanceiro] = useState(false);
  const [menuCadastros, setMenuCadastros] = useState(false);

  const [laudo, setLaudo] = useState(null);

  /* Busca o laudo pelo código (para saber o status real) */
  useEffect(() => {
    if (!codigo) return;

    fetch(`/api/laudos/buscar.php?codigo=${encodeURIComponent(codigo)}`, {
      credentials: 'include'
    })
      .then(r => r.json())
      .then(d => {
        if (d.success) setLaudo(d.laudo);
      })
      .catch(() => null);
  }, [codigo]);

  return (
    <div className="flex min-h-screen bg-[#050810] text-slate-200">

      {/* MENU LATERAL */}
      <MenuParadigmaLateral
        abaAtiva={abaAtiva}
        setAbaAtiva={setAbaAtiva}
        menuFinanceiro={menuFinanceiro}
        setMenuFinanceiro={setMenuFinanceiro}
        menuCadastros={menuCadastros}
        setMenuCadastros={setMenuCadastros}
      />

      {/* ÁREA DO LAUDO */}
      <main className="flex-1 flex flex-col overflow-hidden">

        {/* HEADER (breadcrumb + nome + status) */}
        <LaudoHeader
          codigo={codigo}
          usuario={usuario}
          status={laudo?.status}
        />

        {/* ABAS (6 fases) */}
        <LaudoAbas
          codigo={codigo}
          statusCodigo={laudo?.status}
        />

        {/* CONTEÚDO DA ABA ATIVA */}
        <div className="flex-1 overflow-y-auto">
          <Outlet context={{ laudo, setLaudo }} />
        </div>

      </main>
    </div>
  );
}